import React from 'react'
import styled from 'styled-components'
import { COLORS, SIZES } from '../styles/theme'
import { useObject } from 'react-firebase-hooks/database'
import { NoticeDb } from '../constants/firebaseConfig'

const Wrapper = styled.div`
  marquee {
    ${SIZES.noticeBar}
    position: fixed;
    left: 0;
    right: 0;
    background: ${COLORS.noticeBar};
    z-index: 300;
    color: white;
    font-size: 16px;
    letter-spacing: 1px;
    padding: 2px 0;

    span {
      margin: 0 0.8em;
    }
  }
`

export default function NoticeBar() {
  const [snapshot, loading, error] = useObject(NoticeDb)

  if (loading || error) {
    return <></>
  }

  return (
    <Wrapper>
      <marquee scrollamount={10}>
        <span className="font-weight-bold">{snapshot.val()}</span>

          {/* Hi colleagues, kindly refresh and join OPU Plenary session now. */}
          {/* Welcome to Boehringer Ingelheim MYSG National Conference 2021. Please proceed to OPU Plenary Hall before 8.55am. */}
      </marquee>
    </Wrapper>
  )
}
